import { debounce } from "lodash"
import { useCallback } from "react"
import Send from "../../communication"
import { useScope } from "../../../container/SelectProjectCompanyContainer"

const useGCPSuggestions = () => {
  const { scope } = useScope()
  const loadSuggestions = (value) => {
    return Send.post("/GCP/question", {
      projetos: `'${scope?.id}'`,
      pergunta: value,
    }).then((response) =>
      response.map((data) => {
        return {
          value: data.details[0].id,
          label: data.question,
          projectId: scope?.id,
          details: data.details,
        }
      }),
    )
  }

  const loadOptions = useCallback(
    debounce((value, callback) => {
      loadSuggestions(value).then((options) => callback(options))
    }, 1800),
    [],
  )

  return loadOptions
}

export default useGCPSuggestions
